$(document).ready(function () {
    $.ajax({
        url: 'https://player.nacional.hr/api/playlist?limit=5',
        type: 'GET',
        dataType: 'json', // Expected data format from server
        success: function (response) {
            const data = response.results
            const list = []
            const container = $('.radio-ticker')
            container.empty()

            if (data.length > 0) {
                data.forEach(item => {
                    list.push(`${item.song.artist}: ${item.song.name}`)
                })

                list.forEach(item => {
                    const anchor = $(`<div class="title">${item}</div>`)
                    container.append(anchor)
                })

                let currentIndex = 0
                $('.radio-ticker .title')
                    .eq(currentIndex)
                    .css({ 'display': 'flex', 'opacity': 0 })
                    .animate({ opacity: 1 }, 750)

                let tickerInterval

                function startTicker() {
                    tickerInterval = setInterval(function () {
                        $('.radio-ticker .title').eq(currentIndex).animate({ opacity: 0 }, 500, function () {
                            $(this).css('display', 'none')
                        })

                        setTimeout(function () {
                            currentIndex = (currentIndex + 1) % $('.radio-ticker .title').length

                            $('.radio-ticker .title')
                                .eq(currentIndex)
                                .css({ 'display': 'flex', 'opacity': 0 })
                                .animate({ opacity: 1 }, 750)
                        }, 550)
                    }, 5000)
                }

                function stopTicker() {
                    clearInterval(tickerInterval)
                }

                startTicker()

                document.addEventListener('visibilitychange', function () {
                    if (document.hidden) {
                        stopTicker()
                    } else {
                        startTicker()
                    }
                });
            }
        },
        error: function () {
            const container = $('.radio-ticker')
            const errorMessage = $('<div class="title">Radio NACIONAL</div>')

            container.empty()
            container.append(errorMessage)
        }
    })
})
